import { keyBy } from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getCandidateUdfFields } from "config/candidateFields";
import { selectUdf } from "redux/slices/udfSlice";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import {
  displayUdfFieldValues,
  isPermissionPresent,
} from "utilities/generalUtility";
import { CandidateFieldsSection } from "../candidateFieldsSection";

export const UserDefines = ({
  candidateJobEntry,
  isAssignedToJob,
  getCandidateUdfs,
}) => {
  const udfSlice = useSelector(selectUdf);
  const userRoles = useSelector(selectUser).roles;
  const canEdit =
    candidateJobEntry.isConsiderable !== 0 &&
    isPermissionPresent(K.Permissions.EditCandidate, userRoles) &&
    isAssignedToJob;

  useEffect(() => {
    getCandidateUdfs?.(candidateJobEntry.id);
  }, [candidateJobEntry.id, getCandidateUdfs]);

  const fields = getCandidateUdfFields(udfSlice[K.Redux.CandidateUdf]);

  if (!fields.length) return null;

  const udfValuesById = keyBy(
    displayUdfFieldValues(udfSlice[K.Redux.CandidateUdf]),
    "id",
  );

  const context = {
    data: candidateJobEntry,
    canEdit,
    disabled: !canEdit,
  };

  return (
    <CandidateFieldsSection
      title="UDFs"
      fields={fields}
      context={context}
      getUdfValue={(f) => udfValuesById[f.udfData.id]?.value}
    />
  );
};
